import { createWithToggle } from './createWithToggle';

export const withDropdown = createWithToggle({
    initialState: false,
    stateName: 'isDropdownOpen',
    toggleName: 'toggleDropdown',
});

